import { render, staticRenderFns } from "./TopBaseInfoText.vue?vue&type=template&id=2c91ca16&scoped=true&"
import script from "./TopBaseInfoText.vue?vue&type=script&lang=js&"
export * from "./TopBaseInfoText.vue?vue&type=script&lang=js&"
import style0 from "./TopBaseInfoText.vue?vue&type=style&index=0&id=2c91ca16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c91ca16",
  null
  
)

export default component.exports